const LoaderTitle = (props) => {
    return(
        <div className="text-center">
            <label className="block text-darkBlue text-2xl font-bold mb-4">{props.loadertitle}</label>
            <p className=" opacity-60 font-medium text-sm w-72 mx-auto">{props.loaderdesc}</p>
        </div>
    )
}

export default LoaderTitle;